import { useParams, useSearchParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Video, Clock, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

const fmtTime = (iso) => new Date(iso).toLocaleString([], { timeZone: "America/New_York", weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) + " ET";

export default function OnlineSession() {
  const { id } = useParams();
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const { data, error, isLoading } = useQuery({
    queryKey: ["video-join", id, token],
    queryFn: () => api.get(`/bookings/${id}/video-join`, { params: { token } }).then((r) => r.data),
    refetchInterval: (q) => (q.state.data?.status === "early" ? 30000 : false),
    retry: false, refetchOnWindowFocus: false,
  });

  if (data?.status === "open") {
    return (
      <div className="h-[calc(100vh-80px)] bg-[#0F3A56] p-3" data-testid="online-session-room">
        <iframe title="Online session" src={data.url} allow="camera; microphone; fullscreen; display-capture; autoplay"
          className="w-full h-full rounded-2xl border-0 bg-black" data-testid="online-session-iframe" />
      </div>
    );
  }

  const msg = error ? formatApiError(error.response?.data?.detail) || "We couldn't open this session."
    : data?.status === "early" ? `Your room opens at ${fmtTime(data.opens_at)} — 15 minutes before the start. This page will open it automatically.`
    : data?.status === "ended" ? "This session has ended." : "";

  return (
    <div className="min-h-[70vh] bg-[#F9F7F3] flex items-center justify-center px-6 py-20" data-testid="online-session-page">
      <div className="eyw-card max-w-md w-full p-8 text-left">
        <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-[#5C8A72] font-semibold"><Video size={14} /> Private online session</span>
        {data && (
          <>
            <h1 className="font-serif text-3xl text-[#1A242B] mt-3" data-testid="online-session-title">{data.title}</h1>
            <p className="text-[#4A5D6B] mt-2 flex items-center gap-2 text-sm"><Clock size={14} /> {data.date} at {data.start_time} ET{data.with ? ` · with ${data.with}` : ""}</p>
          </>
        )}
        {isLoading ? <p className="mt-6 flex items-center gap-2 text-[#4A5D6B]"><Loader2 className="animate-spin" size={16} /> Checking your session…</p>
          : <p className="mt-6 text-[#1A242B]" data-testid="online-session-message">{msg}</p>}
        <Link to="/dashboard" className="eyw-btn-ghost !py-2 text-sm mt-6 inline-flex" data-testid="online-session-back">Back to my dashboard</Link>
      </div>
    </div>
  );
}
